import { render } from "./LetTalkButton.vue?vue&type=template&id=526bbab8&scoped=true"
import script from "./LetTalkButton.vue?vue&type=script&lang=js"
export * from "./LetTalkButton.vue?vue&type=script&lang=js"

import "./LetTalkButton.vue?vue&type=style&index=0&id=526bbab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526bbab8"]])

export default __exports__